// extracted by mini-css-extract-plugin
export default {"form":"RenderVegListForm_form__c-10b"};